export default __webpack_public_path__ + "static/media/logo_etmday_negro.0bd12ece.png";